import { memo } from "react";
import { StepTypeEditorProps } from "../types";

export const BeneficialOwnershipStepTypeSpecificProps = memo(
  (_props: StepTypeEditorProps) => null,
);
